<template>
  <div class="show-payment">
    <div @click="setStep(4)" class="show-payment-toggle">
      <div>Forma de pagamento:</div>
      <div v-if="step > 4">{{ paymentTypeText }}</div>
      <i v-if="step > 4" class="fas fa-angle-down"></i>
    </div>
    <transition name="pop" mode="out-in">
      <div v-if="step === 4 && loading" key="loading"><i class="fas fa-spinner loading-big"></i></div>
      <div v-if="step === 4 && !loading" key="payment">
        <div class="show-payment-types">
          <div @click="type = 'savedCard'" v-if="hasCreditCard.name && showPayment.types.includes('credit')" class="show-payment-type payment-card" :class="{ active : type === 'savedCard'}">
            <i v-if="hasCreditCard.type === 'visa'" class="fab fa-cc-visa"></i>
            <i v-else-if="hasCreditCard.type === 'mastercard'" class="fab fa-cc-mastercard"></i>
            <i v-else-if="hasCreditCard.type === 'amex'" class="fab fa-cc-amex"></i>
            <i v-else-if="hasCreditCard.type === 'diners'" class="fab fa-cc-diners-club"></i>
            <i v-else-if="hasCreditCard.type === 'elo'" class="fas fa-credit-card"></i>
            <i v-else-if="hasCreditCard.type === 'hipercard'" class="fas fa-hipercard-card"></i>
            <i v-else-if="hasCreditCard.type === 'discover'" class="fas fa-discover-card"></i>
            <i v-else class="far fa-credit-card"></i>
            <div>XXXXXX XXXXXX XX{{ hasCreditCard.mask }}</div>
            <div>{{ hasCreditCard.name }}</div>
          </div>
          <div @click="type = 'credit'" v-if="showPayment.types.includes('credit')" class="show-payment-type" :class="{ active : type === 'credit'}">
            <i class="fas fa-credit-card"></i> {{ hasCreditCard.name ? 'Outro Cartão' : 'Cartão de Crédito' }}
          </div>
          <div @click="type = 'billet'" v-if="showPayment.types.includes('billet')" class="show-payment-type" :class="{ active : type === 'billet'}">
            <i class="fas fa-barcode"></i> Boleto
          </div>
          <div @click="type = 'pix'" v-if="showPayment.types.includes('pix')" class="show-payment-type" :class="{ active : type === 'pix'}">
            <font-awesome-icon icon="fa-brands fa-pix" /> Pix
          </div>
        </div>
        <form @submit.prevent v-if="type === 'credit'" class="form show-payment-form" style="border-bottom: 1px dashed #ccc">
          <div class="show-payment-line" style="margin: 0 -10px">
            <div class="payment-type">
              <i class="fab fa-cc-visa" style="color: #192061"></i> Visa
            </div>
            <div class="payment-type">
              <i class="fab fa-cc-mastercard" style="color: #e35205"></i> Mastercard
            </div>
            <div class="payment-type">
              <i class="fab fa-cc-amex" style="color: #27aee3 "></i> American Express
            </div>
            <div class="payment-type">
              <i class="fab fa-cc-diners-club" style="color: #2196f3"></i> Diners Club
            </div>
            <div class="payment-type">
              <i class="fas fa-credit-card" style="color: black"></i> Elo
            </div>
            <div class="payment-type">
              <i class="far fa-credit-card" style="color: #b82126"></i> Hipercard
            </div>
          </div>
        </form>
        <form v-show="installments.length > 1 && (type === 'credit' || type === 'savedCard')" @submit.prevent class="form show-payment-form" style="border-bottom: 1px dashed #ccc; padding-bottom: 30px">
          <div class="show-payment-form-break" style="width: 100%">
            <label>Parcelamento</label>
            <select v-model="installment" style="width: 300px">
              <option v-for="i in installments" :key="i.installment" :value="i.installment">
                {{ `${i.installment} x R$ ${i.value.toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }}
                <span v-if="i.installment > 1">(R$ {{ (i.value * i.installment).toLocaleString('pt-br', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }} com juros)</span>
              </option>
            </select>
          </div>
        </form>

        <!-- Credit Card Details -->
        <form @submit.prevent v-if="type === 'credit'" class="form show-payment-form" style="border-bottom: 1px dashed #ccc">
          <div class="show-payment-form-break">
            <label>Número do cartão</label>
            <input v-model="creditNumber" v-mask="'#### #### #### ####'" placeholder="____ ____ ____ ____" type="text" :class="{ error : error.indexOf('creditNumber') > -1 }" style="width: 180px" id="cardNumber" />
            <div v-if="error.indexOf('creditNumber') > -1" class="hint">número de cartão inválido</div>
            <label>Nome no cartão</label>
            <input v-model="creditName" type="text" :class="{ error : error.indexOf('creditName') > -1 }" id="owner" style="text-transform: uppercase" />
            <div v-if="error.indexOf('creditName') > -1" class="hint">nome no cartão inválido</div>
          </div>
          <div class="show-payment-form-break">
            <label>Validade do cartão</label>
            <input v-model="creditValidity" v-mask="'## / ##'" placeholder="xx / xx" type="text" :class="{ error : error.indexOf('creditValidity') > -1 || error.indexOf('card_expiration') > -1 }" style="width: 100px" id="expiration-date" />
            <div v-if="error.indexOf('creditValidity') > -1 || error.indexOf('card_expiration') > -1" class="hint">Validade incorreta MM/AA</div>
            <label>Código de Segurança</label>
            <input v-model="creditCVV" v-mask="'###'" placeholder="xxx" type="text" :class="{ error : error.indexOf('creditCVV') > -1 }" style="width: 100px" id="cvv" />
            <div v-if="error.indexOf('creditCVV') > -1" class="hint">código de segurança inválido</div>
          </div>
          <div class="show-payment-form-break">
            <label class="switch">
              <input v-model="saveCard" type="checkbox">
              <span class="slider"></span>
              <span class="text">Salvar cartão?</span>
            </label>
          </div>
        </form>
        <!-- Billet Details -->
        <form @submit.prevent class="form show-billet-form">
          <div class="show-billet-form-break">
            <label>CPF</label>
            <input v-model="document" v-mask="'###.###.###-##'" placeholder="___.___.___-__" type="text" :class="{ error : error.indexOf('document') > -1 || error.indexOf('registry_code') > -1 }" style="width: 180px" />
            <div v-if="error.indexOf('document') > -1 || error.indexOf('registry_code') > -1" class="hint">CPF inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>CEP</label>
            <div style="display: flex; align-items: center">
              <input v-model="addressPostcode" @input="typePostcode" v-mask="'#####-###'" placeholder="_____-___" type="text" :class="{ error : error.indexOf('addressPostcode') > -1 }" style="width: 180px" />
              <div v-if="loadingPostcode" style="margin-left: 10px"><i class="fas fa-spinner loading"></i></div>
            </div>
            <div v-if="error.indexOf('addressPostcode') > -1" class="hint">CEP inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>Cidade</label>
            <div style="display: flex">
              <input v-model="addressCity" placeholder="Ex: São Paulo" type="text" :class="{ error : error.indexOf('addressCity') > -1 }" style="flex-grow: 1" />
              <select v-model="addressState" type="text" :class="{ error : error.indexOf('addressState') > -1 }" style="width: 60px; margin-left: 10px">
                <option :value="null">-</option>
                <option v-for="state in states" :key="state" :value="state">{{ state }}</option>
              </select>
            </div>
            <div v-if="error.indexOf('addressCity') > -1" class="hint">Cidade inválida</div>
            <div v-if="error.indexOf('addressState') > -1" class="hint">UF inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>Bairro</label>
            <input v-model="addressSuburb" placeholder="Ex: Morumbi" type="text" :class="{ error : error.indexOf('addressSuburb') > -1 }" />
            <div v-if="error.indexOf('addressSuburb') > -1" class="hint">Bairro inválido</div>
          </div>
          <div class="show-billet-form-break" style="width: 100%">
            <label>Endereço</label>
            <input v-model="addressStreet" placeholder="Rua, Avenida, ..." type="text" :class="{ error : error.indexOf('addressStreet') > -1 }" />
            <div v-if="error.indexOf('addressCity') > -1" class="hint">Endereço inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>Número</label>
            <input v-model="addressNumber" placeholder="Ex: 1234" type="text" :class="{ error : error.indexOf('addressNumber') > -1 }" style="width: 180px" />
            <div v-if="error.indexOf('addressNumber') > -1" class="hint">Número inválido</div>
          </div>
          <div class="show-billet-form-break">
            <label>Complemento</label>
            <input v-model="addressAdjunct" placeholder="bl, apto, ..." type="text" :class="{ error : error.indexOf('addressAdjunct') > -1 }" style="width: 180px" />
          </div>
          <div class="show-payment-line" style="margin-top: 20px; margin-left: 10px">
            <button @click="selectPayment()" type="button" class="button-next"><span>Continuar</span><i class="fas fa-angle-right"></i></button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import logger from '../../logger'
import { getFromCEP } from '../api/address'

export default {
  name: 'showPayment',
  props: ['step', 'setStep', 'showPayment', 'total', 'finishPayment', 'preview', 'customer', 'error'],
  data () {
    return {
      loading: false,
      type: null,
      hasCreditCard: {
        name: null,
        type: null,
        mask: null
      },
      creditNumber: null,
      creditValidity: null,
      creditName: null,
      creditCVV: null,
      document: null,
      addressPostcode: null,
      addressState: null,
      addressCity: null,
      addressSuburb: null,
      addressStreet: null,
      addressNumber: null,
      addressAdjunct: null,
      loadingPostcode: false,
      saveCard: false,
      installment: 1,
      states: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT',
        'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RR', 'RO', 'RJ', 'RN', 'RS', 'SC',
        'SP', 'SE', 'TO']
    }
  },
  computed: {
    ...mapState(['user']),
    paymentTypeText () {
      if (this.type === 'credit' || this.type === 'savedCard') return 'Cartão de Crédito'
      else if (this.type === 'pix') return 'Pix'
      else return 'Boleto'
    },
    installments () {
      return this.showPayment.installments.map(x => {
        let value = 0
        if (this.showPayment.clientInterest && x > 1) {
          const fee = this.showPayment.fees.filter(y => y.method === 'credit').find(y => y.installment === x).fee || 0
          value = this.total / (1 - fee / 100) / x
        } else {
          value = this.total / x
        }
        return {
          installment: x,
          value
        }
      }).sort((a, b) => a.installment - b.installment)
    }
  },
  watch: {
    customer (customer) {
      if (customer) {
        this.loading = true
        this.hasCreditCard.name = customer.nameCard
        this.hasCreditCard.type = customer.typeCard
        this.hasCreditCard.mask = customer.maskCard
        if (this.hasCreditCard.name) {
          this.type = 'savedCard'
        } else {
          this.type = 'credit'
        }
        this.document = customer.document
        this.addressPostcode = customer.addressPostcode
        this.addressState = customer.addressState
        this.addressCity = customer.addressCity
        this.addressSuburb = customer.addressSuburb
        this.addressStreet = customer.addressStreet
        this.addressNumber = customer.addressNumber
        this.addressAdjunct = customer.addressAdjunct
        this.loading = false
      }
    },
    creditName (value) {
      this.creditName = value.replace(/[^a-zA-Z ]/g, '')
    }
  },
  methods: {
    selectPayment (type) {
      this.type = type || this.type

      let payment = {
        type: this.type,
        document: this.document,
        addressPostcode: this.addressPostcode,
        addressState: this.addressState,
        addressCity: this.addressCity,
        addressSuburb: this.addressSuburb,
        addressStreet: this.addressStreet,
        addressNumber: this.addressNumber,
        addressAdjunct: this.addressAdjunct,
        saveCard: this.saveCard,
        installments: this.type === 'billet' ? 1 : this.installment
      }
      if (this.type === 'credit') {
        payment.creditNumber = this.creditNumber
        payment.creditValidity = this.creditValidity
        payment.creditName = this.creditName
        payment.creditCVV = this.creditCVV
      }
      this.finishPayment(payment)
    },
    async typePostcode (e) {
      try {
        // Search CEP
        if (e.data && this.addressPostcode.length === 9) {
          this.loadingPostcode = true
          const address = await getFromCEP(this.addressPostcode.replace('-', ''))
          this.addressState = address.state
          this.addressCity = address.city
          this.addressSuburb = address.suburb
          this.addressStreet = address.street
          this.loadingPostcode = false
        }
      } catch (error) {
        this.loadingPostcode = false
        logger.warn(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.show-payment {
  width: 100%;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #d5d5d5;
}

.show-payment-toggle {
  display: flex;
  align-items: center;
  color: #333;
  font-size: 1em;
  font-weight: 300;
  div:nth-child(2) {
    color: $primary-color;
    font-size: 1.1em;
    font-weight: 500;
    margin-left: 10px;
  }
  i {
    flex: 1;
    text-align: right;
    cursor: pointer;
    font-size: 1.6em;
    color: #999;
  }
}

.show-payment-types {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin: 10px -5px;

  .show-payment-type {
    width: 180px;
    height: 100px;
    margin: 5px 5px;
    border: 1px solid $primary-color;
    border-radius: 5px;
    font-size: 1em;
    color: $primary-color;
    padding: 10px 10px;
    text-align: center;
    cursor: pointer;
    &:hover {
      background: $hover-color-2;
    }
    &.active {
      color: #fff;
      background-image: linear-gradient(to bottom right, $primary-color, $secondary-color);
    }
    i, svg {
      width: 100%;
      font-size: 2em;
      margin: 10px 0;
    }
  }

  .payment-card {
    text-align: left;
    i {
      text-align: right;
      margin: 0;
    }
    div:nth-child(2) {
      font-size: 0.9em;
      margin: 15px 0 5px;
    }
    div:nth-child(3) {
      font-size: 0.8em;
      margin: 5px 0;
    }
  }
}

.show-payment-line {
  width: 100%;
  display: flex;
}

.payment-type {
  display: flex;
  align-items: center;
  color: #555;
  font-size: 0.8em;
  /*text-transform: uppercase;*/
  margin: 5px 10px;
  line-height: 19px;
  flex-wrap: wrap;
  i {
    font-size: 1.5em;
    margin-right: 5px;
  }
}

.show-payment-form {
  padding: 10px 0;
  label:first-child {
    margin-top: 20px;
  }
}

.show-payment-form-break {
  display: flex;
  flex-direction: column;
}

.show-billet-form {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 10px 0;
  margin: 0 -10px;
}

.show-billet-form-break {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
}

@media screen and (min-width: $desktop-width) {

  .show-payment-form {
    flex-direction: row;
    flex-wrap: wrap;
    .show-payment-form-break {
      padding-right: 50px;
    }
  }

  .show-payment-form-break {
    width: 50%;
  }

  .show-payment-types {
    justify-content: flex-start;
  }

  .show-billet-form-break {
    width: 50%;
  }

}
</style>
